<div *ngFor="let group of menuItems; index as idx">
    <hr *ngIf="idx > 0" />
    <mat-grid-list cols="2" rowHeight="95px">
        <mat-grid-tile [colspan]="item.colspan || 1" *ngFor="let item of group">
            <button mat-raised-button [routerLink]="[item.path]" color="accent" [disabled]="item.disabled">
                <mat-icon>{{item.icon}}</mat-icon><br />
                <div style="white-space:pre-wrap; line-height:16px !important;">{{item.label}}</div>
            </button>
        </mat-grid-tile>
    </mat-grid-list>
</div>

<div style="margin-top:1em">
    <span style="opacity: 0.5;">Build: {{upToDateService.buildNumberAtStartup}}</span>
    <span *ngIf="!buildIsUpToDate" style="margin-left: 1em; color: yellow;">Update Available</span>
</div>